import initialState from "./initialState";
import * as actions from "./actionTypes";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    // Application Config
    case actions.AUTH: {
      return {
        ...state,
        auth: action.payload,
      };
    }
    case actions.SPARE_ACCESS_RIGHTS: {
      return {
        ...state,
        spareAccessRights: action.payload,
      };
    }
    case actions.TECHNICAL_DOC_ACCESS_RIGHTS: {
      return {
        ...state,
        technicalDocAccessRights: action.payload,
      };
    }
    case actions.ADVISORIES_ACCESS_RIGHTS: {
      return {
        ...state,
        advisoriesAccessRights: action.payload,
      };
    }
    case actions.NOTIFICATIONS_ACCESS_RIGHTS: {
      return {
        ...state,
        notificationsAccessRights: action.payload,
      };
    }
    case actions.NOTIFICATION_READ_STATUS: {
      return {
        ...state,
        isAllNotificateionRead: action.payload,
      };
    }
    case actions.KEY_AND_IV: {
      return {
        ...state,
        keyAndIv: action.payload,
      };
    }
    case actions.SET_NOTIFICATION_COUNT: {
      return {
        ...state,
        notificationCount: action.payload,
      };
    }
    case actions.SET_ROLL_LIST: {
      return {
        ...state,
        rollList: action.payload,
      };
    }
    case actions.SET_MODEL_SEARCH_BRAND: {
      return {
        ...state,
        brandSearchv: action.payload,
      };
    }
    case actions.SET_MODEL_SEARCH_BRICK: {
      return {
        ...state,
        brickSearchv: action.payload,
      };
    }
    case actions.SET_MODEL_SEARCH_MODEL: {
      return {
        ...state,
        searchModelNameValuev: action.payload,
      };
    }



    case actions.SET_SPARE_SEARCH_VENDOR: {
      return {
        ...state,
        vendorSearch_: action.payload,
      };
    }
    case actions.SET_SPARE_SEARCH_ACTION: {
      return {
        ...state,
        actionSearch_: action.payload,
      };
    }
    case actions.SET_SPARE_SEARCH_BRAND: {
      return {
        ...state,
        brandSearch_: action.payload,
      };
    }
    case actions.SET_SPARE_SEARCH_BRICK: {
      return {
        ...state,
        brickSearch_: action.payload,
      };
    }
    case actions.SET_SPARE_SEARCH_PTYPE: {
      return {
        ...state,
        partTypeSearch_: action.payload,
      };
    }
    case actions.SET_SPARE_SEARCH_ACTIVE: {
      return {
        ...state,
        activeSearch_: action.payload,
      };
    }
    case actions.SET_SPARE_SEARCH_MODEL: {
      return {
        ...state,
        searchModelNameValue_: action.payload,
      };
    }
    case actions.SET_SPARE_SEARCH_ARTICLE: {
      return {
        ...state,
        searchArticleCodeValue_: action.payload,
      };
    }
    case actions.SET_SPARE_SEARCH_DESCR: {
      return {
        ...state,
        searchDescriptionValue_: action.payload,
      };
    }

    case actions.CLEAN_STATE: {
      return {
        auth: {},
        spareAccessRights: {},
        technicalDocAccessRights: {},
        advisoriesAccessRights: {},
        notificationsAccessRights: {},
        isAllNotificateionRead: false,
        keyAndIv: {},
        notificationCount: 0,
        rollList: [],
        brandSearchv: "",
        brickSearchv: "",
        searchModelNameValuev: "",
        
        vendorSearch_:'', actionSearch_:'', brandSearch_:'', brickSearch_:'', partTypeSearch_:'', activeSearch_:'', searchModelNameValue_:'', searchArticleCodeValue_:'', searchDescriptionValue_:''
      };
    }
    default: {
      return { ...state };
    }
  }
};

export default reducer;
